// api/distributors.ts
import { apiClient, type PageData } from './client'

// ============================================
// 类型定义
// ============================================

// CRMEB 供应商（直接来自 eb_system_supplier 表）
export interface CrmebSupplier {
	id: number
	supplier_name: string  // 供应商名称
	admin_id: number       // 关联的管理员ID
	avatar: string         // 供应商头像
	is_show: number        // 是否显示
	is_del: number         // 是否删除
}

// 后台用户（简化版）
export interface SimpleUser {
	id: number
	username: string
	nickname: string
	phone: string
	email: string
	avatar: string
	status: number
}

// 分销商列表项
export interface DistributorItem {
	id: number
	username: string
	nickname: string
	phone: string
	crmeb_uid: number | null       // 绑定的 CRMEB 供应商 ID（eb_system_supplier.id）
	crmeb_account: string          // CRMEB 供应商账号（来自 eb_system_admin.account）
	crmeb_real_name: string        // CRMEB 供应商姓名（来自 eb_system_admin.real_name）
	crmeb_phone: string            // CRMEB 供应商电话（来自 eb_system_admin.phone）
	supplier_name: string          // 供应商名称（来自 eb_system_supplier.supplier_name）
}

// 分销商列表筛选参数
export interface DistributorFilterParams {
	page?: number
	page_size?: number
	keyword?: string
	status?: number // 1=已绑定，0=未绑定
}

// 绑定分销商请求
export interface BindDistributorRequest {
	user_id: number
	crmeb_uid: number  // CRMEB 供应商 ID（eb_system_supplier.id）
}

// ============================================
// API 接口
// ============================================

export const distributorApi = {
	// 获取分销商列表
	list: async (params?: DistributorFilterParams): Promise<PageData<DistributorItem>> => {
		const searchParams = new URLSearchParams()
		if (params?.page) searchParams.set('page', String(params.page))
		if (params?.page_size) searchParams.set('page_size', String(params.page_size))
		if (params?.keyword) searchParams.set('keyword', params.keyword)
		if (params?.status !== undefined) searchParams.set('status', String(params.status))

		const response = await apiClient.get<PageData<DistributorItem>>(`/distributors?${searchParams.toString()}`)
		return response.data
	},

	// 绑定分销商
	bind: async (data: BindDistributorRequest): Promise<void> => {
		await apiClient.post('/distributors/bind', data)
	},

	// 解绑分销商
	unbind: async (userId: number): Promise<void> => {
		await apiClient.delete(`/distributors/${userId}/unbind`)
	},

	// 搜索 CRMEB 供应商（直接查询 eb_system_supplier 表）
	searchCrmebSuppliers: async (keyword: string): Promise<CrmebSupplier[]> => {
		const response = await apiClient.get<CrmebSupplier[]>(`/distributors/crmeb-suppliers/search?keyword=${encodeURIComponent(keyword)}`)
		return response.data
	},

	// 搜索后台用户
	searchUsers: async (keyword: string): Promise<SimpleUser[]> => {
		const response = await apiClient.get<SimpleUser[]>(`/distributors/users/search?keyword=${encodeURIComponent(keyword)}`)
		return response.data
	},
}
